import { render, staticRenderFns } from "./ed-presentation-mode-alert.component.vue?vue&type=template&id=0fdcd3e4&scoped=true&"
import script from "./ed-presentation-mode-alert.component.ts?vue&type=script&lang=ts&"
export * from "./ed-presentation-mode-alert.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-presentation-mode-alert.component.scss?vue&type=style&index=0&id=0fdcd3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdcd3e4",
  null
  
)

export default component.exports